import { useState } from 'react'
import { Header } from '../components/layout/Header'
import { Footer } from '../components/layout/Footer'
import { Hero } from '../components/landing/Hero'
import { Features } from '../components/landing/Features'
import { FeatureShowcase } from '../components/landing/FeatureShowcase'
import { Pricing } from '../components/landing/Pricing'
import { CTA } from '../components/landing/CTA'
import { SignupForm } from '../components/landing/SignupForm'

export const Landing = () => {
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false)

  const handleGetStarted = () => {
    setIsSignupModalOpen(true)
  }

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero onGetStarted={handleGetStarted} />
        <Features />
        <FeatureShowcase />
        <Pricing onSignup={handleGetStarted} />
        <CTA onGetStarted={handleGetStarted} />
      </main>
      <Footer />
      <SignupForm
        isOpen={isSignupModalOpen}
        onClose={() => setIsSignupModalOpen(false)}
      />
    </div>
  )
}

